import ManualTradeCurrencySettings from './ManualTradeCurrencySettings';

export default ManualTradeCurrencySettings;
